function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "uploadFile_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  className: "uploadFile_svg__a",
  transform: "translate(103 82)",
  d: "M0 0h24v24H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "uploadFile_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "uploadFile_svg__c",
  d: "M14.283 9.556h5.36a2.35 2.35 0 00-.617-1l-5.268-5.321a2.246 2.246 0 00-1-.626V8.03a1.528 1.528 0 001.525 1.526zM11.615 13.926z"
}), /*#__PURE__*/React.createElement("path", {
  className: "uploadFile_svg__c",
  d: "M14.312 10.351a2.35 2.35 0 01-2.347-2.347V2.51H7.612a2.634 2.634 0 00-1.942.664 2.692 2.692 0 00-.664 1.965v13.743a2.315 2.315 0 002.6 2.621h9.536a2.318 2.318 0 002.605-2.618v-8.368c.007-.056 0-.11 0-.165zm.7 5.4a.486.486 0 01-.5.468.5.5 0 01-.372-.166l-1.047-1.115-.46-.49.039 1.035v2.923a.547.547 0 01-.542.538.553.553 0 01-.552-.538v-2.923l.041-1.032-.46.488-1.047 1.115a.524.524 0 01-.379.166h-.034a.483.483 0 01-.3-.847l2.328-2.246a.512.512 0 01.791 0l2.328 2.246a.475.475 0 01.166.357z"
}));

function SvgUploadFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default SvgUploadFile;